import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ConfirmationService} from "primeng/api";
import {LogicDto} from "../../../model/dto/entity/logic.dto";
import {LogicService} from "../../../service/api/logic.service";
import {LogicCheckSyntaxDto} from "../../../model/dto/entity/logic-check-syntax.dto";
import {LogicCheckSyntaxResponseDto} from "../../../model/dto/entity/logic-check-syntax-response.dto";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {WidgetHelperButton} from "../../../../../core/shared/basic/widget-helper-button";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {LogicLanguage} from "../../../../../core/shared/components/code-mirror-editor/code-mirror-editor.component";
// The 12-value mirror of the backend enum; used to name the persisted language.
import {LogicLanguageEnum} from "../../../enum/logic-language.enum";

@Component({
    selector: 'mvs-lg-logic-object-component',
    templateUrl: './lg-logic-object.component.html',
    standalone: false
})
export class LgLogicObjectComponent
    extends ObjectBaseComponent{


    logicExportService: MvsCrudService;
    logicImportService: MvsCrudService;
    dto: LogicDto;

    script: string;
    language: string;
    currentView: string = 'logic';
    activeTab: number = 0;

    syntaxResponse: LogicCheckSyntaxResponseDto;
    widgetButtons: WidgetHelperButton[];

    handleSidebarButtons() {

        this.widgetButtons = [
            {
                label: null,
                icon: 'fa-regular fa-square-code',
                display: true,
                action: 'logic',
                tooltip: 'Logic'
            }, {
                label: null,
                icon: 'fa-regular fa-flask-vial',
                display: true,
                action: 'testen',
                tooltip: 'Testen'
            },
            {
                label: null,
                icon: 'fa-regular fa-file-import',
                display: true,
                action: 'imports',
                tooltip: 'Imports',
            },
            {
                label: null,
                icon: 'fa-regular fa-file-export',
                display: true,
                action: 'exports',
                tooltip: 'Exports',
            }
        ];

    }

    constructor(protected route: ActivatedRoute,
                protected coreService: MvsCoreService,
                protected confirmationService: ConfirmationService,
                protected messageService: MvsMessageService,
                protected observerService: ObserverService,
                protected logicService: LogicService
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();


        this.logicExportService = this.coreService.getCrudService("lg.LogicExport");
        this.logicImportService = this.coreService.getCrudService("lg.LogicImport");
        this.handleSidebarButtons();
    }


    onObjectChanged() {


        this.setPageTitle(this.dto.name);

        this.script = this.dto.script;

        // Resolved against the 12-value backend mirror, not the editor's own enum: the value is a
        // backend ordinal and the two enums diverge from position 2 on.
        this.language = LogicLanguageEnum[this.dto.logicLanguage as unknown as number];

    }


    checkSyntax() {
        const codeSyntaxDto: LogicCheckSyntaxDto = new LogicCheckSyntaxDto();

        codeSyntaxDto.logicId = this.objectIdentifier.objectId;
        codeSyntaxDto.logicLanguage = this.dto.logicLanguage;
        codeSyntaxDto.code = this.script;

        this.logicService.checkCodeSyntax(codeSyntaxDto).subscribe(checkSyntax => {
            this.syntaxResponse = checkSyntax;
        })
    }

    updateScript() {

        const logicDto: LogicDto = new LogicDto();
        logicDto.id = this.dto.id;
        logicDto.script = this.script;
        logicDto.logicLanguage = this.dto.logicLanguage;

        this.logicService.update(logicDto).subscribe((res: LogicDto) => {
            this.dto = res;
            this.messageService.showSuccessMessage('Update', 'Logic has benn updated.');
        });

    }

    onContentChange(content: string) {
        this.script = content;
    }

    handleLogicLanguageChange(event: LogicLanguage) {
        this.dto.logicLanguage = event;
    }

    setView(view: string) {
        this.currentView = view;
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);

        if (!this.initialized) {
            return;
        }

        // this.handleLogicVariables();
    }


}
